import './Text-ca7603b7.css';

var classes = {"Text":"prc-Text-Text-0ima0"};

export { classes as default };
